import { React, useEffect, useState, useRef } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardActions from '@mui/material/CardActions';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import IconButton from '@mui/material/IconButton';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import Avatar from '@mui/material/Avatar';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import DownloadIcon from '@mui/icons-material/Download';
import Collapse from '@mui/material/Collapse';
import ShippingDetails from './ShippingDetails';

export default function BusinessCard(props) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [nameType, setNameType] = useState('FIRST');
    const [size, setSize] = useState('Small');
    const [isExpanded, setIsExpanded] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [showShippingDetails, setShowShippingDetails] = useState(false);

    useEffect(() => {
        loadPreview(nameType, size); // only called once
    }, []);

    function loadPreview(nameOption, sizeOption) {
        let postData = {
            nameType: nameOption,
            size: 'small'
        }
        TokenService.post(postData, 'Returner_DownloadBusinessCard')
            .then((response) => {
                //response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setImagePreview("data:image/png;base64," + jsonData.BusinessCardLarge);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function handleDownloadBusinessCard() {
        let postData = {
            nameType: nameType,
            size: size
        }
        TokenService.post(postData, 'Returner_DownloadBusinessCard')
            .then((response) => {
                //response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    downloadImage(jsonData.BusinessCardLarge, 'BusinessCard.png');


                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function downloadImage(base64Image, fileName) {
        // Convert Base64 to Uint8Array
        var byteCharacters = atob(base64Image);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);

        // Create a Blob from the Uint8Array
        var blob = new Blob([byteArray], { type: 'image/png' });

        // Create a URL for the Blob
        var url = URL.createObjectURL(blob);

        // Create a temporary anchor element
        var link = document.createElement('a');
        link.href = url;
        link.download = fileName;

        // Trigger the download
        link.click();

        // Clean up the URL and anchor element
        URL.revokeObjectURL(url);
    }

    function handleNameOptionChange(event) {
        setNameType(event.target.value);
        loadPreview(event.target.value, 'Small');
    }

    function handleToggleExpand()  {
        setIsExpanded(!isExpanded);
    }

    function handleRequestPrints() {
        setShowShippingDetails(true);
    }

    function handleCloseShippingDetails(didAccept, shippingDetails) {
        if (didAccept) {
            // send to server
            if (shippingDetails != null) {
                let postData = {
                    flyerName: props.flyerName,
                    nameType: nameType,
                    shippingInfo: JSON.stringify(shippingDetails)
                }
                TokenService.post(postData, 'Returner_RequestPrintFlyer')
                    .then((response) => {
                        //response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            enqueueSnackbar('Thanks for your request. We will update you once we complete the order.', {
                                variant: 'success',
                            });

                        }
                        else {
                            enqueueSnackbar(response.Message, {
                                variant: 'error',
                            });
                        }
                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });
            }
        }
        setShowShippingDetails(false);
    }

    return (
        <Card>
            <div style={{ fontWeight: 'bold', fontSize: 22 }}>
                Business Card
            </div>

            {imagePreview == null ? 
                <Skeleton variant="rectangular" width={350} height={200} />
                :

                <CardMedia
                    component="img"
                    alt="business card"

                    image={imagePreview}
                />
            }
           
            <CardContent>
              
                <Collapse in={isExpanded} timeout='auto' unmountOnExit>
                    <div style={{ fontStyle: 'italic', fontSize: '10pt' }}>
                        * QR Code allows customers to request you.
                    </div>
                    <div style={{ marginTop: '25px' }}>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group">Name Options</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={nameType}
                                onChange={handleNameOptionChange}
                            >
                                <FormControlLabel value="FIRST" control={<Radio />} label="First name only" />
                                <FormControlLabel value="FIRSTANDLAST" control={<Radio />} label="First and Last name" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div style={{ marginTop: '25px' }}>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group">Image Size</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={size}
                                onChange={(e) => setSize(e.target.value)}
                            >
                                <FormControlLabel value="Small" control={<Radio />} label="For Digital Sharing (smaller)" />
                                <FormControlLabel value="Full" control={<Radio />} label="Printable (larger)" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div style={{ marginTop: '25px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' onClick={() => handleDownloadBusinessCard()}>Download <DownloadIcon /></Button>
                        <Button variant='outlined' onClick={() => handleRequestPrints()}>Request Prints</Button>
                    </div>
                </Collapse>
               
            </CardContent>
            <div style={{ backgroundColor: 'var(--sipzee-gray-3)', height:'35px' }} onClick={() => handleToggleExpand()}>
                {isExpanded ?
                  
                     <div>
                        <div style={{fontSize:'8pt', fontStyle:'italic'} }>show less</div>
                        <ExpandLessIcon />
                    </div>
                    :
                    <div>
                        <div style={{fontSize:'8pt', fontStyle:'italic'} }>show more</div>
                        <ExpandMoreIcon />
                    </div>
                }
            </div>
            {!showShippingDetails ? null :
                <ShippingDetails Close={(didAccept, shippingDetails) => handleCloseShippingDetails(didAccept, shippingDetails)} />
            }
        </Card>

    )
}